import { h } from 'preact';

import PreviewHomeEditor from 'components/editor/movies/home/preview/homePreview';

// Only used in Universal Movie Platform
export default (props) => <PreviewHomeEditor {...props} />;